<template>
  <div>
    <el-dialog
      title="选择专辑"
      :visible="dialogVisible"
      :before-close="handleClose"
      width="600px"
    >
      <el-input
        placeholder="请输入专辑名称"
        v-model="searchAlbumName"
        class="input-with-select"
        size="small"
        @keyup.enter.native="searchAlbum()"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="searchAlbum()"
        ></el-button>
      </el-input>
      <el-table
        ref="albumTable"
        :data="albumList"
        tooltip-effect="dark"
        style="width: 100%"
        row-key="albumId"
        @selection-change="tableSelectionChange"
      >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="55"
        ></el-table-column>
        <el-table-column label="专辑名称" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.albumName }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="albumTotal > 5"
        class="pagination"
        background
        :page-size="5"
        :pager-count="5"
        layout="total, prev, pager, next, jumper"
        :total="albumTotal"
        @current-change="currentChange"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog()">取 消</el-button>
        <el-button type="primary" @click="saveSelect()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/assets/js/api";
export default {
  name: "ShopCenterAdminWebSelectAlbumDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    selectedList: {
      type: Array,
      default: () => [],
    },
    courseId: {
      type: [String, Number],
      default: "",
    },
    scenarioId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      dialogVisible: false,
      searchAlbumName: "", // 搜索的专辑名称
      albumList: [], // 专辑列表
      albumTotal: 0, // 专辑总数
      albumPage: 1, // 专辑当前页
      albumDialogSelection: [], // 弹窗中选中的专辑
    };
  },
  watch: {
    show: {
      handler: function (val) {
        this.dialogVisible = val;
        this.albumDialogSelection = this.selectedList;
        if (val) {
          this.getAlbumList();
        }
      },
    },
  },
  mounted() {},

  methods: {
    closeDialog() {
      // 清空选中状态
      this.$refs.albumTable.clearSelection();
      // 清空关键词
      this.searchAlbumName = "";
      // 清空专辑信息
      this.albumList = [];
      this.albumTotal = 0;
      this.albumPage = 1;
      // 关闭
      this.$emit("update:show", false);
    },
    handleClose(done) {
      done();
      this.closeDialog();
    },
    // 弹窗搜索专辑
    searchAlbum() {
      // 调用接口搜索数据
      this.getAlbumList();
    },
    // 获取专辑列表
    async getAlbumList() {
      const album = await this.$axios.get(
        api.shopResource.pageAlbumList +
          "?pageIndex=" +
          this.albumPage +
          "&pageSize=5" +
          "&title=" +
          this.searchAlbumName +
          "&courseId=" +
          (this.courseId || 0) +
          "&scenarioId=" +
          this.scenarioId
      );
      this.albumList = album.result.list;
      this.albumTotal = album.result.totalCount;
      this.$nextTick(() => {
        // 重新设置选中状态
        this.albumList.forEach((item) => {
          const index = this.albumDialogSelection.findIndex(
            (item2) => item2.albumId === item.albumId
          );
          if (index > -1) {
            this.$refs.albumTable.toggleRowSelection(item, true);
          }
        });
      });
    },
    // 选择专辑
    tableSelectionChange(selection) {
      this.albumDialogSelection = selection;
    },
    // 选择专辑弹窗的分页
    currentChange(val) {
      this.albumPage = val;
      // 调用接口获取数据
      this.getAlbumList();
    },
    // 保存选择的专辑
    saveSelect() {
      this.$emit("getSelectAlbum", this.albumDialogSelection);
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
.input-with-select {
  width: 50%;
}
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px auto 0;
}
::v-deep .el-dialog__body {
  padding: 0 20px 20px;
}
::v-deep .el-table__header-wrapper .el-checkbox {
  display: none;
}
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    margin: 0 40px;
  }
}
</style>
